// https://github.com/import-js/eslint-plugin-import/issues/2266
/* eslint-disable import/no-unresolved */
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

const addSwipers = () => {
  const suiSwipers = document.getElementsByClassName('sui-swiper')

  Array.from(suiSwipers).forEach((swiper, index) => {
    const suiSwiper = swiper

    if (!suiSwiper.classList.contains(`swiper-container-${index}`)) {
      suiSwiper.innerHTML = `<div class="swiper-wrapper">${suiSwiper.innerHTML}</div>`
      suiSwiper.classList.add(`swiper-container-${index}`)
      const prevClassName = `prev-${index}`
      const nextClassName = `next-${index}`
      suiSwiper.insertAdjacentHTML(
        'beforeend',
        `<div class="${prevClassName} swiper-button-prev swiper-button"></div><div class="${nextClassName} swiper-button-next swiper-button"></div>`,
      )

      const suiSwiperSlide = document.querySelectorAll('.sui-swiper-slide')
      suiSwiperSlide.forEach((slide) => {
        slide.classList.add('swiper-slide')
      })
      let options = {
        direction: 'horizontal',
        loop: true,
        spaceBetween: 5,
        centeredSlides: false,
        slidesPerView: 1,
        autoHeight: false,
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: `.${nextClassName}`,
          prevEl: `.${prevClassName}`,
        },
      }
      const numberOfSlidesPerView = suiSwiper.getAttribute('data-slides-per-view') || 1

      if (numberOfSlidesPerView > 1) {
        options = {
          ...options,
          breakpoints: {
            548: {
              slidesPerView: Math.max(numberOfSlidesPerView - 2, 1),
            },
            768: {
              slidesPerView: Math.max(numberOfSlidesPerView - 1, 1),
            },
            992: {
              slidesPerView: numberOfSlidesPerView,
            },
          },
        }
      }
      const paginationRequired = suiSwiper.getAttribute('data-pagination') || false

      const paginationClassName = `swiper-pagination-${index}`
      if (paginationRequired) {
        suiSwiper.insertAdjacentHTML('beforeend', `<div class="${paginationClassName} swiper-pagination"></div>`)
        options = {
          ...options,
          pagination: {
            el: `.${paginationClassName}`,
            type: 'bullets',
            clickable: true,
          },
        }
      }

      // eslint-disable-next-line no-new
      new Swiper(`.swiper-container-${index}`, options)
    }
  })
}

document.addEventListener('DOMContentLoaded', () => addSwipers())
